
import React, { useEffect, useState } from 'react';

const FearGreedScore: React.FC = () => {
  const [score, setScore] = useState<number | null>(null);
  const [label, setLabel] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetch('/api/fear-and-greed/history')
      .then(async res => {
        if (res.status === 204) throw new Error('Aucune donnée disponible');
        if (!res.ok) throw new Error('Erreur serveur');
        const text = await res.text();
        if (!text) throw new Error('Aucune donnée reçue');
        try {
          return JSON.parse(text);
        } catch {
          throw new Error('Réponse invalide');
        }
      })
      .then(data => {
        if (data && data.data && data.data.length > 0) {
          setScore(Number(data.data[0].value));
          setLabel(data.data[0].value_classification);
        } else {
          setError('Aucune donnée historique');
        }
        setLoading(false);
      })
      .catch(e => {
        setError(e.message);
        setLoading(false);
      });
  }, []);

  return (
    <div style={{
      flex: 1,
      background: '#fff',
      borderRadius: 24,
      padding: '32px 24px',
      boxShadow: '0 2px 16px #0001',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      minHeight: 120,
      justifyContent: 'center',
    }}>
      <div style={{ fontSize: 22, fontWeight: 700, color: '#43a047' }}>Fear & Greed</div>
      {loading ? (
        <div style={{ fontSize: 24, marginTop: 8 }}>Chargement...</div>
      ) : error ? (
        <div style={{ fontSize: 18, color: '#e74c3c', marginTop: 8 }}>{error}</div>
      ) : (
        <>
          <div style={{ fontSize: 48, fontWeight: 900, marginTop: 8 }}>{score}</div>
          <div style={{ fontSize: 18, marginTop: 4 }}>{label}</div>
        </>
      )}
    </div>
  );
};

export default FearGreedScore;
